import { render } from "./reports.vue?vue&type=template&id=eecc45e6"
import script from "./reports.vue?vue&type=script&lang=js"
export * from "./reports.vue?vue&type=script&lang=js"

import "./reports.vue?vue&type=style&index=0&id=eecc45e6&lang=scss"
script.render = render

export default script